import React, { useState } from 'react'
import { Box } from '@usap/uicomponents'
import GuestInfoRMAForm from './Forms/GuestInfoRMAForm'
import RMAReturnDetails from './Forms/RMAReturnDetails'
import BreadcrumbTab from '../../common/BreadcrumbTab'
import RMASuccess from './RMASuccess'
import ReturnDetails from '../OrderDetails/ReturnDetails/ReturnDetails'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import { RMADetailBoxWMO, RMADetailWrapperWMO, Heading } from './style/RMAWMO.css'
import GuestInfoRMAFormWmo from './Forms/GuestInfoRMAFormWmo'

const tabData = ['Return Details', 'Return Confirmation']

const RMAForm = (props) => {
  const {
    isDesktop,
    isBot,
    Link,
    loading,
    setLoading,
    onSubmit,
    onCancelReturn,
    orderDetails,
    handleReason,
    GTM,
    appSteps,
    setAppSteps,
    imgSteps,
    setImgSteps,
    customerOrder,
    setCustomerOrder,
    fileUpload,
    setFileUpload,
    siteKey,
    formFile,
    setFormFile,
    tempStep,
    setTempStep,
    reqElem,
    setReqElem,
    returnQuantity,
    setReturnQuantity,
    tokenCustomerId,
    showTabs,
    setShowTabs,
    formFileMain,
    setFormFileMain,
    docSteps,
    setDocSteps,
    mechanicDiagnosis,
    creditStatus,
    returnRequestStatus,
    returnReasonUtils,
    OpenChatHandler,
  } = props

  const [data, setData] = useState(orderDetails)
  const [doneReturn, setDoneReturn] = useState('')
  const [displayReturnDetails, setDisplayReturnDetails] = useState(false)
  const [returnDetailsData, setReturnDetailsData] = useState({})
  const forceMultipleSelect = false
  const handleData = resultData => {
    setData(resultData)
  }
  const cancelReturn = () => {
    setDoneReturn('')
    setData('')
    onCancelReturn()
  }

  const isWmoEnabled = useWmoEnabled()

  if (!data) {
    if (isWmoEnabled) {
      return (
        <Box
          width="100%"
          margin={{ horizontal: 'auto', vertical: '0px' }}
          pad={isDesktop ? 'medium' : 'small'}
        >
          <GuestInfoRMAFormWmo
            key="returnForm"
            onSubmit={onSubmit}
            Link={Link}
            siteKey={siteKey}
            handleData={handleData}
            handleReason={handleReason}
            isDesktop={isDesktop}
            setLoading={setLoading}
          />
        </Box>
      )
    }

    return (
      <Box
        width="640px"
        margin={{ horizontal: 'auto', vertical: '0px' }}
        pad={isDesktop ? 'medium' : 'small'}
      >
        <GuestInfoRMAForm
          key="returnForm"
          onSubmit={onSubmit}
          Link={Link}
          siteKey={siteKey}
          handleData={handleData}
          handleReason={handleReason}
        />
      </Box>
    )
  }

  if (doneReturn) {
    return (
      <Box
        width="1000px"
        margin={{ horizontal: 'auto', vertical: '0px' }}
        pad={isDesktop ? 'medium' : 'small'}
      >
        <BreadcrumbTab
          key="breadcrumbTabSuccess"
          data={tabData}
          bgColor="#a3a3a3"
          bgActiveColor="#333"
          activeStep={1}
        />
        <RMASuccess
          key="confirmationRMA"
          isDesktop={isDesktop}
          orderDetails={orderDetails}
          handleDone={cancelReturn}
          OpenChatHandler={OpenChatHandler}
        />
      </Box>
    )
  }

  if (displayReturnDetails) {
    return (
      <ReturnDetails
        Link={Link}
        isDesktop={isDesktop}
        creditStatus={creditStatus}
        returnReasonUtils={returnReasonUtils}
        returnDetailsData={returnDetailsData}
        returnRequestStatus={returnRequestStatus}
        setReturnDetailsData={setReturnDetailsData}
        setDisplayReturnDetails={setDisplayReturnDetails}
        OpenChatHandler={OpenChatHandler}
      />
    )
  }

  if (isWmoEnabled) {
    return (
      <RMADetailWrapperWMO>
        {showTabs && (
          <Heading>Return Details</Heading>
        )}
        <RMADetailBoxWMO showTabs={showTabs}>
          <RMAReturnDetails
            key="detailsOrderReturn"
            isDesktop={isDesktop}
            Link={Link}
            isBot={isBot}
            data={data}
            onCancelReturn={cancelReturn}
            loading={loading}
            setLoading={setLoading}
            setDoneReturn={setDoneReturn}
            handleReason={handleReason}
            appSteps={appSteps}
            setAppSteps={setAppSteps}
            imgSteps={imgSteps}
            setImgSteps={setImgSteps}
            docSteps={docSteps}
            setDocSteps={setDocSteps}
            customerOrder={customerOrder}
            fileUpload={fileUpload}
            setFileUpload={setFileUpload}
            formFile={formFile}
            setFormFile={setFormFile}
            tempStep={tempStep}
            setTempStep={setTempStep}
            reqElem={reqElem}
            forceMultipleSelect={forceMultipleSelect}
            setReqElem={setReqElem}
            GTM={GTM}
            setReturnQuantity={setReturnQuantity}
            returnQuantity={returnQuantity}
            setReturnDetailsData={setReturnDetailsData}
            setDisplayReturnDetails={setDisplayReturnDetails}
            setCustomerOrder={setCustomerOrder}
            tokenCustomerId={tokenCustomerId}
            showTabs={showTabs}
            setShowTabs={setShowTabs}
            formFileMain={formFileMain}
            setFormFileMain={setFormFileMain}
            mechanicDiagnosis={mechanicDiagnosis}
            creditStatus={creditStatus}
            returnRequestStatus={returnRequestStatus}
            OpenChatHandler={OpenChatHandler}
          />
        </RMADetailBoxWMO>
      </RMADetailWrapperWMO>
    )
  }

  return (
    <Box
      width="1000px"
      margin={{ horizontal: 'auto', vertical: '0px' }}
      pad={isDesktop ? 'medium' : 'small'}
    >
      {showTabs && (
        <BreadcrumbTab
          key="breadcrumbTabReturn"
          data={tabData}
          bgColor="#a3a3a3"
          bgActiveColor="#333"
          activeStep={0}
        />
      )}
      <RMAReturnDetails
        key="detailsOrderReturn"
        isDesktop={isDesktop}
        Link={Link}
        isBot={isBot}
        data={data}
        onCancelReturn={cancelReturn}
        loading={loading}
        setLoading={setLoading}
        setDoneReturn={setDoneReturn}
        handleReason={handleReason}
        appSteps={appSteps}
        setAppSteps={setAppSteps}
        imgSteps={imgSteps}
        setImgSteps={setImgSteps}
        docSteps={docSteps}
        setDocSteps={setDocSteps}
        customerOrder={customerOrder}
        fileUpload={fileUpload}
        setFileUpload={setFileUpload}
        formFile={formFile}
        setFormFile={setFormFile}
        tempStep={tempStep}
        setTempStep={setTempStep}
        reqElem={reqElem}
        forceMultipleSelect={forceMultipleSelect}
        setReqElem={setReqElem}
        GTM={GTM}
        setReturnQuantity={setReturnQuantity}
        returnQuantity={returnQuantity}
        setReturnDetailsData={setReturnDetailsData}
        setDisplayReturnDetails={setDisplayReturnDetails}
        setCustomerOrder={setCustomerOrder}
        tokenCustomerId={tokenCustomerId}
        showTabs={showTabs}
        setShowTabs={setShowTabs}
        formFileMain={formFileMain}
        setFormFileMain={setFormFileMain}
        mechanicDiagnosis={mechanicDiagnosis}
        creditStatus={creditStatus}
        returnRequestStatus={returnRequestStatus}
        OpenChatHandler={OpenChatHandler}
      />
    </Box>
  )
}

export default RMAForm
